import { useCallback } from 'react';

import { useIsUserFavorited } from '@/apis/aniftyBackend/creations/userFavorite/getIsUserFavorited';
import useAccessToken from '@/hooks/useAccessToken';
import useWalletAddress from '@/hooks/useWalletAddress';

import { useAddFavoriteUser } from './addFavoriteUser';
import { useDeleteFavoriteUser } from './deleteFavoriteUser';

export const useMyUserFavorite = ({
  targetUserID,
}: {
  targetUserID: string;
}) => {
  const { currentAccountAddress: currentUserID } = useWalletAddress();

  const { data: isUserFavorited } = useIsUserFavorited({
    userID: currentUserID,
    targetUserID,
    config: {
      enabled: !!currentUserID,
    },
  });

  const { accessToken, requestSignature } = useAccessToken();

  const { mutate: addFavoriteUser } = useAddFavoriteUser();

  const { mutate: deleteFavoriteUser } = useDeleteFavoriteUser();

  const toggle = useCallback(async () => {
    if (isUserFavorited) {
      deleteFavoriteUser({ targetUserID });
      return;
    }

    addFavoriteUser({ targetUserID });
  }, [
    accessToken,
    requestSignature,
    isUserFavorited,
    deleteFavoriteUser,
    addFavoriteUser,
    targetUserID,
  ]);

  return {
    isUserFavorited,
    toggle,
  };
};
